import React, { forwardRef } from 'react';
import { cn } from '../../lib/utils';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
  href?: string;
}
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  className,
  variant = 'primary',
  size = 'md',
  fullWidth,
  href,
  children,
  ...props
}, ref) => {
  const baseStyles = 'inline-flex items-center justify-center rounded-xl font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-500 focus-visible:ring-offset-2 focus-visible:ring-offset-[#0a0e1a] disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-amber-500 text-slate-900 hover:bg-amber-400 shadow-[0_0_20px_rgba(245,185,66,0.3)] hover:shadow-[0_0_30px_rgba(245,185,66,0.5)]',
    secondary: 'bg-slate-800 text-white hover:bg-slate-700 border border-slate-700',
    outline: 'border-2 border-amber-500 text-amber-500 hover:bg-amber-500/10'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg',
    xl: 'h-16 px-10 text-xl'
  };
  const classes = cn(baseStyles, variants[variant], sizes[size], fullWidth && 'w-full', className);
  const content = <motion.button ref={ref} className={cn(classes, 'text-[14px] font-[600] pl-[48px] pr-[48px]')} whileHover={{
    scale: 1.02,
    y: -2
  }} whileTap={{
    scale: 0.98
  }} {...props} data-id="element-330">
        {children}
      </motion.button>;
  if (href) {
    return <a href={href} className={cn(fullWidth && 'w-full block', 'focus-visible:outline-none')} data-id="element-331">
          {content}
        </a>;
  }
  return content;
});
Button.displayName = 'Button';